module.exports = __webpack_public_path__ + "media/images/room/live_v1-fd09c988aced0bb76862cd3a914eaab5.png";